import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@fortawesome/fontawesome-free/css/all.css'
import 'vuetify/dist/vuetify.css' //  Preload static Vuetify CSS

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'md'
  },
  theme: {
    // don't completely disable theming; the previous configuration had
    // `disable: true` which prevents Vuetify from generating its colour
    // classes.  As a result any button that uses a named colour such as
    // `color="warning"` just falls back to the default grey.  You can
    // either remove this flag or at least provide all of the colours you
    // need explicitly.  The simplest fix is to turn theming back on and
    // add a `warning` entry (and any other missing colours) so that the
    // colour props on `<v-btn>` actually work.
    //
    // See https://vuetifyjs.com/en/features/theme/ for details.
    themes: {
      light: {
        primary: '#1f5b41',
        secondary: '#7BC243',
        anchor: '#1f5b41',
        accent: '#1f5b41',
        accentd: '#4E4E4E',
        warning: '#f39c12' // colour used by "Reject" buttons etc.
      },
      dark: {
        primary: '#1f5b41',
        secondary: '#7BC243',
        anchor: '#1f5b41',
        accent: '#1f5b41',
        accentd: '#4E4E4E',
        warning: '#f39c12'
      }
    }
  }
})
